"use strict";

exports.__esModule = true;
/**
 * Constants for token types
 */

exports["default"] = {
  WHITESPACE: "whitespace",
  WORD: "word",
  STRING: "string",
  RESERVED: "reserved",
  RESERVED_TOPLEVEL: "reserved-toplevel",
  RESERVED_NEWLINE: "reserved-newline",
  OPERATOR: "operator",
  OPEN_PAREN: "open-paren",
  CLOSE_PAREN: "close-paren",
  LINE_COMMENT: "line-comment",
  BLOCK_COMMENT: "block-comment",
  NUMBER: "number",
  PLACEHOLDER: "placeholder"
};
module.exports = exports["default"];